import {
    NTR_CTA_BUTTON, NTR_CTA_SUBTITLE, NTR_CTA_TITLE,
    NTR_DISCLAIMER_BODY, NTR_DISCLAIMER_EYEBROW, NTR_DISCLAIMER_TITLE,
    NTR_DOCS_EYEBROW, NTR_DOCS_ITEM1, NTR_DOCS_ITEM2, NTR_DOCS_ITEM3,
    NTR_DOCS_ITEM4, NTR_DOCS_ITEM5, NTR_DOCS_ITEM6, NTR_DOCS_SUBTITLE, NTR_DOCS_TITLE,
    NTR_FAQ_A1, NTR_FAQ_A2, NTR_FAQ_A3, NTR_FAQ_A4, NTR_FAQ_A5,
    NTR_FAQ_EYEBROW, NTR_FAQ_Q1, NTR_FAQ_Q2, NTR_FAQ_Q3, NTR_FAQ_Q4, NTR_FAQ_Q5,
    NTR_FAQ_SUBTITLE, NTR_FAQ_TITLE,
    NTR_HELMET_DESCRIPTION, NTR_HELMET_TITLE,
    NTR_HERO_CTA_BOOK, NTR_HERO_CTA_CALL, NTR_HERO_EYEBROW, NTR_HERO_SUBTITLE,
    NTR_HERO_TITLE, NTR_HERO_TITLE_ACCENT,
    NTR_HERO_TRUST_BILINGUAL, NTR_HERO_TRUST_COMMISSIONED, NTR_HERO_TRUST_MOBILE,
    NTR_PROCESS_EYEBROW,
    NTR_PROCESS_STEP1_DESC, NTR_PROCESS_STEP1_TITLE,
    NTR_PROCESS_STEP2_DESC, NTR_PROCESS_STEP2_TITLE,
    NTR_PROCESS_STEP3_DESC, NTR_PROCESS_STEP3_TITLE,
    NTR_PROCESS_TITLE,
    NTR_SERVICES_EYEBROW, NTR_SERVICES_SUBTITLE, NTR_SERVICES_TITLE,
    NTR_SERVICE_ACK_DESC, NTR_SERVICE_ACK_TITLE,
    NTR_SERVICE_COPY_DESC, NTR_SERVICE_COPY_TITLE,
    NTR_SERVICE_JURAT_DESC, NTR_SERVICE_JURAT_TITLE,
    NTR_SERVICE_POA_DESC, NTR_SERVICE_POA_TITLE,
    NTR_SERVICE_VEHICLE_DESC, NTR_SERVICE_VEHICLE_TITLE,
    NTR_SERVICE_WEDDING_DESC, NTR_SERVICE_WEDDING_TITLE,
} from "../types";

const en_notary_page = {
    helmet: {
        [NTR_HELMET_TITLE]: "Bilingual notary services | Linares Pro Corp",
        [NTR_HELMET_DESCRIPTION]: "Commissioned bilingual notary public for acknowledgments, jurats, copy certifications, vehicle title transfers, power of attorney, and wedding ceremonies.",
    },
    section: {
        hero: {
            [NTR_HERO_EYEBROW]: "Notary public",
            [NTR_HERO_TITLE]: "Notary services,",
            [NTR_HERO_TITLE_ACCENT]: "done right and on time.",
            [NTR_HERO_SUBTITLE]: "Commissioned bilingual notary public. We handle acknowledgments, jurats, copy certifications, power of attorney, vehicle titles, and even wedding ceremonies.",
            [NTR_HERO_CTA_BOOK]: "Book my notary",
            [NTR_HERO_CTA_CALL]: "Call now",
            [NTR_HERO_TRUST_COMMISSIONED]: "Commissioned & bonded",
            [NTR_HERO_TRUST_BILINGUAL]: "English & Spanish",
            [NTR_HERO_TRUST_MOBILE]: "Mobile service available",
        },
        services: {
            [NTR_SERVICES_EYEBROW]: "What we notarize",
            [NTR_SERVICES_TITLE]: "Every common notary act, covered.",
            [NTR_SERVICES_SUBTITLE]: "If you're not sure which notary act you need, just ask — we'll tell you on the phone.",
            [NTR_SERVICE_ACK_TITLE]: "Acknowledgments",
            [NTR_SERVICE_ACK_DESC]: "We verify your identity and confirm you signed the document willingly — the most common notary act.",
            [NTR_SERVICE_JURAT_TITLE]: "Jurats (sworn statements)",
            [NTR_SERVICE_JURAT_DESC]: "You sign in front of us and swear or affirm that the statements in your document are true.",
            [NTR_SERVICE_COPY_TITLE]: "Copy certifications",
            [NTR_SERVICE_COPY_DESC]: "We certify that a copy is a true and accurate copy of the original document you bring.",
            [NTR_SERVICE_WEDDING_TITLE]: "Wedding ceremonies",
            [NTR_SERVICE_WEDDING_DESC]: "A friendly, professional ceremony to legalize your marriage — in English or Spanish.",
            [NTR_SERVICE_VEHICLE_TITLE]: "Vehicle title transfers",
            [NTR_SERVICE_VEHICLE_DESC]: "Notarization of vehicle titles and bills of sale so your transfer is accepted at the DMV.",
            [NTR_SERVICE_POA_TITLE]: "Power of attorney",
            [NTR_SERVICE_POA_DESC]: "Notarization of power-of-attorney documents so someone you trust can act on your behalf.",
        },
        docs: {
            [NTR_DOCS_EYEBROW]: "What to bring",
            [NTR_DOCS_TITLE]: "Before you walk in.",
            [NTR_DOCS_SUBTITLE]: "Bringing these makes your appointment fast and easy.",
            [NTR_DOCS_ITEM1]: "Valid government-issued photo ID (driver's license, state ID, or passport)",
            [NTR_DOCS_ITEM2]: "The complete document you need notarized — do not sign it ahead of time",
            [NTR_DOCS_ITEM3]: "Any witnesses required by the document (we can sometimes help arrange these)",
            [NTR_DOCS_ITEM4]: "For copy certifications: the original document and the copy",
            [NTR_DOCS_ITEM5]: "For vehicle titles: the title, registration, and IDs of all parties",
            [NTR_DOCS_ITEM6]: "Payment for the notary fee",
        },
        process: {
            [NTR_PROCESS_EYEBROW]: "How it works",
            [NTR_PROCESS_TITLE]: "Three simple steps.",
            [NTR_PROCESS_STEP1_TITLE]: "Book your time",
            [NTR_PROCESS_STEP1_DESC]: "Walk in or call ahead — we'll tell you exactly what to bring.",
            [NTR_PROCESS_STEP2_TITLE]: "Verify & sign",
            [NTR_PROCESS_STEP2_DESC]: "We verify your ID, you sign in front of us, and we complete the notary certificate.",
            [NTR_PROCESS_STEP3_TITLE]: "Seal & deliver",
            [NTR_PROCESS_STEP3_DESC]: "We apply our seal, log the act in our journal, and you walk out with a valid notarized document.",
        },
        faq: {
            [NTR_FAQ_EYEBROW]: "Notary FAQ",
            [NTR_FAQ_TITLE]: "Common notary questions.",
            [NTR_FAQ_SUBTITLE]: "Not sure if a notary can do what you need? Just call.",
            [NTR_FAQ_Q1]: "Do I need an appointment?",
            [NTR_FAQ_A1]: "Walk-ins are welcome, but an appointment guarantees you'll be served quickly. Calling ahead is the best way to avoid waiting.",
            [NTR_FAQ_Q2]: "Should I sign the document before I come in?",
            [NTR_FAQ_A2]: "No. For most notary acts, you must sign in front of the notary. If you already signed, bring it anyway — we'll explain your options.",
            [NTR_FAQ_Q3]: "What ID do you accept?",
            [NTR_FAQ_A3]: "A current, government-issued photo ID: driver's license, state ID, U.S. passport, or foreign passport. Expired IDs are usually not accepted.",
            [NTR_FAQ_Q4]: "Can you notarize a document in Spanish?",
            [NTR_FAQ_A4]: "Yes. We are bilingual and can communicate clearly with you in Spanish, even if the document itself is in English.",
            [NTR_FAQ_Q5]: "Can you give me legal advice?",
            [NTR_FAQ_A5]: "No. Notaries cannot give legal advice or prepare legal documents. If you need legal advice, we'll point you toward a qualified professional.",
        },
        cta: {
            [NTR_CTA_TITLE]: "Need something notarized today?",
            [NTR_CTA_SUBTITLE]: "Call ahead and we'll have you in and out in minutes.",
            [NTR_CTA_BUTTON]: "Call now",
        },
        disclaimer: {
            [NTR_DISCLAIMER_EYEBROW]: "Important notice",
            [NTR_DISCLAIMER_TITLE]: "A Florida notary is not an attorney.",
            [NTR_DISCLAIMER_BODY]: "As a Florida notary public, we are not licensed to practice law in Florida and may not give legal advice or accept fees for legal advice. The notarial act only verifies the identity of the signer \u2014 not the truthfulness, legality, or completeness of the document itself. If you need legal guidance about the contents of a document, please consult a licensed Florida attorney.",
        },
    },
};

export default en_notary_page;
